import type { PatchRequestStatus } from '@shared/patch-request';
import type { StatusMeta } from '@/components/status-tone';

/** T-57: a patch request's status, for StatusBadge. */
export const PATCH_STATUS_META: Record<PatchRequestStatus, StatusMeta> = {
  pending: { label: 'Waiting for an admin', tone: 'warning' },
  applying: { label: 'Applying', tone: 'info' },
  applied: { label: 'Applied', tone: 'success' },
  rejected: { label: 'Rejected', tone: 'neutral' },
};
